import { Redirect, useSearch } from "wouter";
import { ROUTES, absolutePath } from "@/lib/routes";

/**
 * Customers folded into Tenants (round 6 T-04, owner 2026-10-02: "Rename. No need to use
 * Customer. Keep it simple"; platform 0027). The route stays declared (`mergedInto` in
 * `APP_ROUTES`: no nav entry, the same permission gate and the same "no instance needed" scope),
 * so a saved link still lands: `/admin/customers` opens Tenants, keeping `?tenant=<id>`, which
 * opens that tenant's dialog.
 */
export default function AdminCustomersRedirect() {
  const search = useSearch();
  const tenantId = new URLSearchParams(search).get("tenant");
  const target = tenantId
    ? `${ROUTES.adminTenants}?tenant=${encodeURIComponent(tenantId)}`
    : ROUTES.adminTenants;
  return <Redirect to={absolutePath(target)} replace />;
}
